import theme from '../../theme';
function ResourceBar({ workers, materials, energy }) {
  const bars = [
    { label: 'Workers', used: workers, total: 100 },
    { label: 'Material', used: materials, total: 100 },
    { label: 'Energy', used: energy, total: 100 },
  ];

  return (
    <div style={{ display: 'flex', gap: '8px', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
      {bars.map(({ label, used, total }) => {
        const remaining = total - used;
        const pct = Math.max(0, (remaining / total) * 100);
        const warn = remaining < 10;
        return (
          <div key={label} style={{
            flex: '1 1 90px',
            minWidth: '90px',
            background: theme.bgDark,
            borderRadius: '4px',
            border: '1px solid rgba(184, 149, 90, 0.2)',
            padding: '10px 12px',
          }}>
            <div style={{ fontSize: '12px', color: theme.textMuted, marginBottom: '4px' }}>{label} left</div>
            <div style={{
              fontSize: '18px',
              fontWeight: '500',
              color: warn ? theme.error : theme.textPrimary,
            }}>
              {remaining}
            </div>
            <div style={{
              height: '3px',
              borderRadius: '2px',
              background: theme.bgCard,
              marginTop: '6px',
              overflow: 'hidden',
            }}>
              <div style={{
                height: '100%',
                borderRadius: '2px',
                background: warn ? theme.error : theme.gold,
                width: `${pct}%`,
                transition: 'width 0.2s',
              }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ResourceBar;
